import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import LoginPage from "./Containers/LoginPage/LoginPage";
import ProtectedRoute from "./Utils/ProtectedRoutes";
import AdminLayout from "./Components/Layout/AdminLayout";
import routes from "./Utils/routes";
import useHtpp from "./Utils/useHttps";
import { useEffect, useState } from "react";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("token"));
  const { configureHeaders, configureInterceptors } = useHtpp();
  useEffect(() => {
    configureHeaders();
    configureInterceptors();
  }, [configureHeaders, configureInterceptors]);

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
  };

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            isLoggedIn ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/login"
          element={<LoginPage onLoginSuccess={handleLoginSuccess} />}
        />

        <Route
          path="/*"
          element={
            <ProtectedRoute isLoggedIn={isLoggedIn}>
              <AdminLayout>
                <Routes>
                  {routes.map((route, index) => {
                    // Handle grouped routes
                    if (route.isGroup && route.children) {
                      return route.children.map((child, childIndex) => (
                        <Route 
                          key={`${index}-${childIndex}`} 
                          path={child.path} 
                          element={<child.element />} 
                        />
                      ));
                    }
                    // Handle regular routes
                    if (route.path && route.element) {
                      return (
                        <Route 
                          key={index} 
                          path={route.path} 
                          element={<route.element />} 
                        />
                      );
                    }
                    return null;
                  }).flat()}
                </Routes>
              </AdminLayout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
